import React from 'react';
import { TableFooter } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { doChipStore } from '../../store/doChipStore';
import { allChipsTotal } from '../../helpers/chipsTotal';
import { useClearDemoStore } from '../../hooks/useClearDemoStore';
import { winningAmountStore } from '../../store/winningAmountStore';

export const FooterWr = observer(() => {
  const { betsTotalAmount } = doChipStore;
  const { clearDemoStateHandler } = useClearDemoStore();
  const { lastWinAmount } = winningAmountStore;

  return (
    <TableFooter
      lastWin={lastWinAmount}
      totalBet={betsTotalAmount}
      demoSwitcherAdditionalFunction={clearDemoStateHandler}
    />
  );
});
